// css
import 'assets/style/elements/breadcrumb.scss'

function Element({ level = '1', className, data = [], style = {}, textStyle = {} }) {
  if (level == '2') className += ' depth-2'
  return (
    <ul className={'breadcrumb ' + className}>
      {data?.map((item, index) => (
        <li key={`breadcrumb_${index}`}>
          <span className="text" style={textStyle}>
            {item}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default Element
